import { TOGGLE_DISPLAY_RESULTS_CARD } from '../../../actions/budgetBenchmarkCalculator/calculator';
import { budgetBenchmarkFormTracking } from './calculator';

export const budgetBenchmarkTracking = (store, next, action) => {
    if (action.type === TOGGLE_DISPLAY_RESULTS_CARD) {
        return budgetBenchmarkFormTracking(store, next, action);
    }
}
